import * as React from "react";
import { SVGProps } from "react";

const HelpJiraButton = (props: SVGProps<SVGSVGElement>) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-help-circle"
      {...props}
    >
      <circle cx={12} cy={12} r={10} />
      <path d="M9.09 9a3 3 0 1 1 5.82 1c0 2-3 3-3 3" />
      <line x1={12} y1={17} x2={12} y2={17} />
    </svg>
);

export default HelpJiraButton;
